import { Box, Typography } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { observer } from 'mobx-react';
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { Layout } from '@roc/feature-app-core';
import { VerticalBarLoader } from '@roc/ui';
import { isNil } from '@roc/feature-utils';
import { PublicBorrowerSetupToDoService } from '../../../../../../libs/feature-borrowers/src/borrowerSetupToDo/services/publicBorrowerSetupToDoService';
import { useAppRoutes } from '../../hooks';

const publicBorrowerSetupToDoService = new PublicBorrowerSetupToDoService();

/**
 * Legacy /borrower-details-verification/:uuid links (already sent by email) now open the
 * credit authorization flow: /soft-credit-pull when credit is run, /background-pull otherwise.
 * The new pages resolve the borrower and request from the requestToken alone.
 */
export const PublicBorrowerSetupToDo = observer(() => {
  const { uuid } = useParams<{ uuid: string }>();
  const { replace } = useHistory();
  const { publicRoutes } = useAppRoutes();
  const [invalidLink, setInvalidLink] = useState(false);

  useEffect(() => {
    publicBorrowerSetupToDoService.getBorrowerDetailsVerification(uuid)
      .then(response => {
        const formInfo = response?.data?.data;
        if (isNil(formInfo?.savedForm)) {
          setInvalidLink(true);
          return;
        }
        const route = formInfo.runCredit ? publicRoutes.softCreditPullWithParams : publicRoutes.backgroundPullWithParams;
        const encodedParams = btoa(JSON.stringify({ requestToken: uuid }));
        replace(route.url.replace(':encodedParams', encodedParams));
      })
      .catch(() => setInvalidLink(true));
  }, [uuid]);

  if (!invalidLink) {
    return <VerticalBarLoader />;
  }

  return (
    <Layout maxWidth="md">
      <Box textAlign={'left'}>
        <Typography variant={'h3'}>{'Credit Authorization'}</Typography>
      </Box>
      <Box mt={4}>
        <Alert severity="warning">This link is invalid. Please contact us for a new link.</Alert>
      </Box>
    </Layout>
  );
});
